import { Modal, Spin } from "antd";
import { FormEventHandler } from "react";
import { IconAlert } from "../../../Icons/IconAlert";
import { Botao } from "../../Botao";
import { LoadingOutlined } from "@ant-design/icons";
const loadingIcon = <LoadingOutlined style={{ fontSize: 24, color: 'white' }} spin />;

interface ConfirmDeleteModalProps {
  isModalOpen: boolean;
  closeModal?: () => void;
  title: string;
  footerContent?: React.ReactNode;
  onSubmit?: FormEventHandler | undefined;
  onDelete?:  () => void;
  mensagem?: string;
  isLoading?: boolean;
}

export function ConfirmDeleteModal({ isModalOpen, title, closeModal, onSubmit, onDelete, mensagem, isLoading }: ConfirmDeleteModalProps) {

  return (
    <Modal
      className="h-[80vh] flex justify-center items-center"
      open={isModalOpen}
      title={title}
      onCancel={closeModal}
      footer={
        <form className="flex flex-row justify-between" onSubmit={onSubmit}>
          <div className="flex flex-row items-center gap-4">
            <Botao
              type="button"
              onClick={closeModal}
              texto="Cancelar"
              className="bg-white border rounded-md hover:bg-gray-1"
            />
          </div>
          <Botao
            type="button"
            onClick={onDelete}
            texto={isLoading ? <span><Spin indicator={loadingIcon} /> Excluindo</span> : 'Excluir'}
            className="bg-error text-white"
          />
        </form>
      }
    >
      <div className="flex flex-col items-center justify-center">
        <IconAlert className="mb-6" />
        <span>{mensagem}</span>
        <strong>Essa ação é irreversível.</strong>
        </div>
    </Modal>
  );
}
